import PurchaseTrainingPendingModal from './PurchaseTrainingPendingModal.vue';

export default PurchaseTrainingPendingModal;
